import vueSlider from 'vue-slider-component';
import axios from 'axios';

export default {
    template: '<transition name="fade">' +
            '<div class="price-calculator__address-list" v-show="show && addressList.length > 0"> ' +
                '<p>Select address </p>' +
                '<ul> ' +
                    '<li v-for="(address, k) in addressList">' +
                        '<label :for="address[k]" v-bind:class="{active:address==selected}">' +
                            '<input :id="address[k]" name="selectedAddress" type="radio" :value="address" v-model="selected" /> ' +
                            '<div class="o-body">{{address.summary}}</div>' +
                        '</label>' +
                    '</li>' +
                '</ul>' +
            '</div>' +
        '</transition>',
    name: 'address-list',
    components: {
        vueSlider
    },
    data () {
        return {
            selected : null,
            addressList : [],
            show: false
        }
    },
    methods : {
        reload(postcode) {
            let endpoint = '/actions/storefirst/quote/get-address-list';

            return axios.post(endpoint, this.getCsrfAwareParams({'postcode' : postcode}))
                .then(response => {
                    this.addressList = response.data;
                    this.show = true;

                    if(this.addressList.length == 0) {
                        this.reject();
                    }
                })
                .catch((error) => {
                    this.$snotify.error(
                        "Sorry, we couldn't find your address. Please try again or add your address manually",
                        'Error'
                    );
                });
        },
        getCsrfAwareParams(additional = {}) {
            var params = new URLSearchParams();

            params.append(window.csrfTokenName, window.csrfTokenValue);

            Object.entries(additional)
                .forEach((p) =>  {
                    let key = p[0];
                    let val = p[1];

                    if(typeof val === "object" && val != null) {
                        params.append(key, JSON.stringify(val));
                    } else {
                        params.append(key, val ? val : '');
                    }
                });

            return params;
        },
    },
    watch : {
        selected(val) {
            this.$emit('changed', this.selected);
        }
    }
}
